import { colorModeSelectors } from "./atoms/sprinkles.css.mjs";
const makeSelector = (mode, styles) => !styles || Object.keys(styles).length === 0 ? {} : {
  [colorModeSelectors[mode]]: styles
};
const colorModeStyle = ({
  lightMode,
  darkMode
}) => ({
  ...lightMode || darkMode ? {
    selectors: {
      ...makeSelector("light", lightMode),
      ...makeSelector("dark", darkMode)
    }
  } : {}
});
export {
  colorModeStyle
};
